import { schema } from "normalizr";

const editHistories = new schema.Entity("editHistories");

const Schemas = {
    EDIT_HISTORY_ARRAY: { data: [editHistories] }
};

export default Schemas;
